// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  min-height: 200px;
}

.spinner-dots {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}

.dot {
  width: 16px;
  height: 16px;
  background: var(--accent-primary);
  border-radius: 50%;
  animation: spin-pulse 1.4s infinite ease-in-out both;
}

.dot:nth-child(1) {
  animation-delay: -0.32s;
}

.dot:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes spin-pulse {
  0%, 80%, 100% {
    transform: scale(0.6);
    opacity: 0.3;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Rotating animation for the container */
.spinner-dots {
  animation: rotate 2s linear infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-text {
  color: var(--text-secondary);
  font-size: 1rem;
  font-weight: 500;
  margin: 17px 0 0 0;
}

.slow-loading-message {
  color: var(--text-tertiary);
  font-size: 0.9rem;
  font-style: italic;
  margin: 12px 0 0 0;
  animation: fadeIn 0.5s ease-in;
}

.reload-page-btn {
  margin-top: 12px;
  padding: 6px 16px;
  font-size: 0.85rem;
  border: 1px solid var(--accent-primary, #666);
  border-radius: 6px;
  background: transparent;
  color: var(--accent-primary, #666);
  cursor: pointer;
  animation: fadeIn 0.5s ease-in;
}

.reload-page-btn:hover {
  background: var(--accent-primary, #666);
  color: var(--bg-primary, #fff);
}


@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LoadingSpinner/LoadingSpinner.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,oDAAoD;AACtD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,yCAAyC;AACzC;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,6CAA6C;EAC7C,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;EACvC,8BAA8B;AAChC;;;AAGA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".loading-spinner-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 40px 20px;\r\n  min-height: 200px;\r\n}\r\n\r\n.spinner-dots {\r\n  display: flex;\r\n  gap: 12px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.dot {\r\n  width: 16px;\r\n  height: 16px;\r\n  background: var(--accent-primary);\r\n  border-radius: 50%;\r\n  animation: spin-pulse 1.4s infinite ease-in-out both;\r\n}\r\n\r\n.dot:nth-child(1) {\r\n  animation-delay: -0.32s;\r\n}\r\n\r\n.dot:nth-child(2) {\r\n  animation-delay: -0.16s;\r\n}\r\n\r\n@keyframes spin-pulse {\r\n  0%, 80%, 100% {\r\n    transform: scale(0.6);\r\n    opacity: 0.3;\r\n  }\r\n  40% {\r\n    transform: scale(1);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* Rotating animation for the container */\r\n.spinner-dots {\r\n  animation: rotate 2s linear infinite;\r\n}\r\n\r\n@keyframes rotate {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.loading-text {\r\n  color: var(--text-secondary);\r\n  font-size: 1rem;\r\n  font-weight: 500;\r\n  margin: 17px 0 0 0;\r\n}\r\n\r\n.slow-loading-message {\r\n  color: var(--text-tertiary);\r\n  font-size: 0.9rem;\r\n  font-style: italic;\r\n  margin: 12px 0 0 0;\r\n  animation: fadeIn 0.5s ease-in;\r\n}\r\n\r\n.reload-page-btn {\r\n  margin-top: 12px;\r\n  padding: 6px 16px;\r\n  font-size: 0.85rem;\r\n  border: 1px solid var(--accent-primary, #666);\r\n  border-radius: 6px;\r\n  background: transparent;\r\n  color: var(--accent-primary, #666);\r\n  cursor: pointer;\r\n  animation: fadeIn 0.5s ease-in;\r\n}\r\n\r\n.reload-page-btn:hover {\r\n  background: var(--accent-primary, #666);\r\n  color: var(--bg-primary, #fff);\r\n}\r\n\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-10px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
